import { render, staticRenderFns } from "./PatientOdImageUpload.vue?vue&type=template&id=7396376e&scoped=true"
import script from "./PatientOdImageUpload.vue?vue&type=script&lang=js"
export * from "./PatientOdImageUpload.vue?vue&type=script&lang=js"
import style0 from "./PatientOdImageUpload.vue?vue&type=style&index=0&id=7396376e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7396376e",
  null
  
)

export default component.exports